import EnterpriseGroupModel                     from 'Models/directory/EnterpriseGroupModel';
import EnterpriseTypeModel                      from 'Models/directory/EnterpriseTypeModel';
import SupplierEnterpriseModel                  from 'Models/supplier/SupplierEnterpriseModel';
import doc                                      from 'decorators/doc';
import model                                    from 'decorators/model';
import { Timestampable }                        from 'helpers/traits';
import { Blamable }                             from 'helpers/traits';
import DirectoryPrivateApiModel                 from 'modelx/models/abstracts/DirectoryPrivateApiModel';

@model.staticLabel('Entreprise', false)
@model.urnResource('enterprise')
@doc.path('/enterprises/{?id}')
export default class EnterpriseModel extends Blamable(Timestampable(DirectoryPrivateApiModel)) {
	public _filters: ModelFiltersExtended<{
		'commercialName': string;
		'companies.tags[serviceUrn][tagReference]': id;
		'country': id;
		'enterpriseCountryEnterpriseProperties.countryEnterpriseProperty.enterpriseProperty': id;
		'enterpriseCountryEnterpriseProperties.countryEnterpriseProperty.enterpriseProperty.reference': DirectoryEnterprisePropertyReference;
		'enterpriseCountryEnterpriseProperties.value': string;
		'enterpriseGroup': id;
		'enterprisePartitions.clientPartitions.clients.subPartitionUrn': Urn;
		'enterprisePartitions.partitionUrn': Urn;
		'enterpriseType': id;
		'enterpriseType.reference': DirectoryEnterpriseTypeReference;
		'name': string;
		'number': number;
		'reference': DirectoryEnterpriseReference;
		'tags[serviceUrn][tagReference]': id;
		'tags[$:registry:service:supplier][supplier]'
	}> = {};

	public _sorts: ModelSortsExtended<{
		'commercialName': string;
		'country': string;
		'id': string;
		'name': string;
		'number': string;
		'reference': string;
	}> = {};

	@doc.string declare commercialName: string;
	@doc.string declare country: string;
	@doc.model(EnterpriseGroupModel) declare enterpriseGroup: EnterpriseGroupModel;
	@doc.model(EnterpriseTypeModel) declare enterpriseType: EnterpriseTypeModel;
	@doc.string declare name: string;
	@doc.number declare number: number;
	@doc.string declare reference: DirectoryEnterpriseReference;

	@model.reverseResolvable<SupplierEnterpriseModel>({ multipleRequests: true, urn: '$:supplier:supplier_enterprise', useUrn: true })
	public declare supplierEnterprise: SupplierEnterpriseModel;
}